/* tslint:disable */
/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:request-list:view:list */

export interface ViewListBlockParams {
	containerRID: string;
	enableFileBrowser?: boolean;
	isFrozen?: boolean;
}
/** Block parameters for urn:block:request-list:provider */

export interface ProviderBlockParams {
	containerRID: string;
}
/** Zone parameters for urn:zone:request-list:provider:children */

export interface ProviderChildrenZoneParams {}
/** Contract Data for urn:zone:request-list:provider:children */

export interface ProviderChildrenContractData {
	canCreateDocReq?: boolean;
}

export namespace BlockNames {
	export const ViewList = 'urn:block:request-list:view:list' as const;
	export type ViewList = 'urn:block:request-list:view:list';
	export const Provider = 'urn:block:request-list:provider' as const;
	export type Provider = 'urn:block:request-list:provider';
}

export namespace ZoneTypes {
	export const ProviderChildren = 'urn:zone:request-list:provider:children' as const;
	export type ProviderChildren = 'urn:zone:request-list:provider:children';
}

export type ViewListProps = ShellProps & BlockParams & ViewListBlockParams;
export type ProviderProps = ShellProps & BlockParams & ProviderBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:request-list:view:list']: BlockParams & ViewListBlockParams;
		['urn:block:request-list:provider']: BlockParams & ProviderBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:zone:request-list:provider:children']: ProviderChildrenZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:zone:request-list:provider:children']: ProviderChildrenContractData;
	}
}
